
import { useEffect, useState } from "react";
import LoaderForSearch from "../Common/LoaderForSearch";
import SmallLoader from "../Common/smallLoader";
import { onlyNumber } from "../../CommonMethhods/CommonMethods";

function AdvanceTaxReportTable(props) {
    const downloadLoader = props?.downloadLoader;
    let finalData = props?.finalData;
    const handleScroll = props?.handleScroll;
    const scrollLoader = props?.scrollLoader;
    const surchargeData = props?.surchargeData;
    const healthEduData = props?.healthEduData;

    const [outsideValues, setOutsideValues] = useState({});
    const [bankInterest, setBankInterest] = useState("");
    const [advanceTaxPaid, setAdvanceTaxPaid] = useState("");
    const [tdsCredit, setTdsCredit] = useState("");

    const tableStructure = [
        "Intraday / Speculation",
        "Short Term Gain / Loss (Less than 365 days)",
        "Long Term Gain / Loss (More than 365 days)",
        "Future & Options / Derivatives Gain / Loss",
        "Dividend",
    ];

    const tableCalculationLabel = [
        "Bank Interest Amount Credited in Bank account",
        "Advance Tax Payable (A)",
        "Surcharge (B)",
        "Health and Education Cess (C)",
        "Total Advance Tax Payable (D = A + B + C)",
        "Advance Tax Paid (E)",
        "TDS Credit for Dividend + Bank Interest Received (F)",
    ];

    const gainKeys = [
        "speculation",
        "shortTerm",
        "longTerm",
        "fno",
        "dividend",
    ];

    const handleOutsideChange = (key, value) => {
        setOutsideValues((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    // const totalGainTaxes = gainKeys.map((key) => {
    //     const insideAmount = finalData?.capitalGainInsideBajajBroking?.[key]?.amount || 0;
    //     const outsideAmount = Number(outsideValues[key] || 0);
    //     return insideAmount + outsideAmount;
    // });

    const advanceTaxPayable =
    gainKeys.reduce((sum, key) => {
        const insideTax =
            finalData?.capitalGainInsideBajajBroking?.[key]?.tax || 0;

        const outsideAmount = Number(outsideValues[key] || 0);

        const taxPerc =
            finalData?.capitalGainOutsideBajajBroking?.[key]?.taxPerc || 0;

        const outsideTax = (outsideAmount * taxPerc) / 100;

        return sum + insideTax + outsideTax;
    }, 0) +
    ((Number(bankInterest || 0) *
        (finalData?.capitalGainOutsideBajajBroking?.dividend?.taxPerc ||
         finalData?.capitalGainInsideBajajBroking?.dividend?.taxPerc ||
         0)) / 100);

    // if (bankInterest !== "") {
    //     totalGainTaxes.push(Number(bankInterest));
    // }

    // const advanceTaxPayable = totalGainTaxes.reduce((sum, val) => sum + val, 0);


    const getSurchargePercentage = (taxableAmount) => {
        if (!Array.isArray(surchargeData)) return 0;

        const rangeMatch = surchargeData.find((item) => {
            if (!item?.dataRange) return false;
            const [minStr, maxStr] = item.dataRange.split("-");
            const min = Number(minStr);
            const max = Number(maxStr);
            return taxableAmount >= min && taxableAmount <= max;
        });

        if (rangeMatch) return Number(rangeMatch.taxPerc);
        const belowRange = surchargeData.find(
            (item) =>
            item.range?.toLowerCase().includes("below") &&
            taxableAmount < 5000000
        );

        if (belowRange) return Number(belowRange.taxPerc);

        const aboveRange = surchargeData.find(
            (item) =>
            item.range?.toLowerCase().includes("above") &&
            taxableAmount > 50000000
        );

        if (aboveRange) return Number(aboveRange.taxPerc);

        return 0;
        };

    const surchargePerc = getSurchargePercentage(advanceTaxPayable);

    const surchargeAmount = surchargePerc > 0 ? (advanceTaxPayable * surchargePerc) / 100 : 0;

    const calculateHealthEduCess = () => {
        const baseAmount =
            (Number(advanceTaxPayable) || 0) +
            (Number(surchargeAmount) || 0);

        const cessPercentage = Number(healthEduData?.[0]?.taxPerc) || 0;
        return (baseAmount * cessPercentage) / 100;

    };
    const healthEduValue = calculateHealthEduCess();

    const totalAdvanceTaxPayable =
        (Number(advanceTaxPayable) || 0) +
        (Number(surchargeAmount) || 0) +
        (Number(healthEduValue) || 0);

    const netAdvanceTaxPayable =
        (Number(totalAdvanceTaxPayable) || 0) -
        (advanceTaxPaid ? Number(advanceTaxPaid) : 0) -
        (tdsCredit ? Number(tdsCredit) : 0);

        const dividendTaxPerc =
    finalData?.capitalGainOutsideBajajBroking?.dividend?.taxPerc ||
    finalData?.capitalGainInsideBajajBroking?.dividend?.taxPerc ||
    0;

        const bankInterestTax =
    (Number(bankInterest || 0) * dividendTaxPerc) / 100;

    useEffect(() => {

        if (!finalData) return;
        const capitalGainInsideBB = tableStructure.map((label, index) => {
            const key = gainKeys[index];
            return {
                particular: label,
                amount:
                    finalData?.capitalGainInsideBajajBroking?.[key]?.amount ?? null,
                tax:
                    finalData?.capitalGainInsideBajajBroking?.[key]?.tax ?? null,
            };
        });

        const capitalGainOutsideBB = tableStructure.map((label, index) => {
            const key = gainKeys[index];
            const outsideAmount = Number(outsideValues[key] || 0);
            const taxPerc =
                finalData?.capitalGainOutsideBajajBroking?.[key]?.taxPerc ?? 0;

            return {
                particular: label,
                amount: outsideAmount,
                tax: (outsideAmount * taxPerc) / 100,
            };
        });


        const capitalGainTotal = tableStructure.map((label, index) => {
            const key = gainKeys[index];
            const insideAmount =
                finalData?.capitalGainInsideBajajBroking?.[key]?.amount || 0;
            const insideTax =
                finalData?.capitalGainInsideBajajBroking?.[key]?.tax || 0;
            const outsideAmount =
                Number(outsideValues[key] || 0);
            const taxPerc =
                finalData?.capitalGainOutsideBajajBroking?.[key]?.taxPerc || 0;
            const outsideTax =
                (outsideAmount * taxPerc) / 100;

            return {
                particular: label,
                amount: insideAmount + outsideAmount,
                tax: insideTax + outsideTax,
            };
        });

        capitalGainTotal.push({
            particular:
                "Bank Interest Amount Credited in Bank Account",
            amount: Number(bankInterest) || 0,
            tax: bankInterestTax,
        });

        const calculations = [
            { particular: "Advance Tax Payable (A)", amount: advanceTaxPayable },
            { particular: "Surcharge (B)", amount: surchargeAmount },
            { particular: "Health and Education Cess (C)", amount: healthEduValue },
            {
                particular: "Total Advance Tax Payable (D = A + B + C)",
                amount: totalAdvanceTaxPayable,
            },
            {
                particular: "Advance Tax Paid (E)",
                amount: Number(advanceTaxPaid) || 0,
            },
            {
                particular:
                    "TDS Credit for Dividend + Bank Interest Received (F)",
                amount: Number(tdsCredit) || 0,
            },
        ];

        const payload = {
            capitalGainInsideBB,
            capitalGainOutsideBB,
            capitalGainTotal,
            calculations,
            netAdvanceTaxPayable,
            advanceTaxLiability: netAdvanceTaxPayable,
        };

        props.setTaxReportPayload(payload);
    }, [
        outsideValues,
        bankInterest,
        advanceTaxPaid,
        tdsCredit,
        advanceTaxPayable,
        surchargeAmount,
        healthEduValue,
        totalAdvanceTaxPayable,
        netAdvanceTaxPayable,
    ]);

    const handlePasteNumbersOnly = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text");
        const numbersOnly = pastedData.replace(/\D/g, "");

        const input = e.target;
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const currentValue = input.value;

        const maxLength = 15;
        const allowedLength =
        maxLength - (currentValue.length - (end - start));
        const trimmedNumbers = numbersOnly.slice(0, allowedLength);
        const newValue =
        currentValue.slice(0, start) +
        trimmedNumbers +
        currentValue.slice(end);

        input.value = newValue;
        input.setSelectionRange(
            start + trimmedNumbers.length,
            start + trimmedNumbers.length
        );

    };

    return (
        <>
            <div className="table-responsive report-table-wrapper ad-tax-table">
                {finalData ? (

                    <table className="table last-column">
                        <thead>
                            <tr>

                                <th scope="col" className="">
                                    Particulars
                                </th>
                                <th scope="col" className="">
                                    Amount
                                </th>
                                <th scope="col">
                                    Tax
                                </th>
                            </tr>
                        </thead>
                        <tbody className="tax-body"
                        // id="clientrevenue-scroll" onScroll={handleScroll}
                        >

                            {tableStructure.map((label, index) => {
                                const key = gainKeys[index];
                                const apiRow =
                                    finalData?.capitalGainInsideBajajBroking?.[key];

                                return (
                                    <tr key={index}>
                                        <td>{label}</td>
                                        <td className="text-end">
                                            {apiRow?.amount.toLocaleString() || "0"}
                                        </td>
                                        <td className="text-end">
                                            {apiRow?.tax?.toLocaleString() || "0"}
                                        </td>
                                    </tr>
                                );
                            })}

                            <tr className="section-header">
                                <td colSpan="3" style={{ fontWeight: "500" }}>
                                    Equity Market - Capital Gain - Outside Bajaj Broking (Including MF)
                                </td>
                            </tr>

                            {tableStructure.map((label, index) => {

                                const key = gainKeys[index];
                                const apiRow =
                                    finalData?.capitalGainOutsideBajajBroking?.[key];

                                const inputValue =
                                    outsideValues[key] ?? apiRow?.amount ?? "";

                                const taxValue =
                                    (Number(inputValue || 0) *
                                        (apiRow?.taxPerc || 0)) /
                                    100;
                                return (
                                    <tr key={`outside-${index}`}>
                                        <td>{label}</td>
                                        <td className="text-end">
                                            <input
                                                type="text"
                                                className="form-control text-end"
                                                value={inputValue}
                                                onInput={onlyNumber}
                                                maxLength={15}
                                                onPaste={(e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    handleOutsideChange(key, pasted);
}}
                                                // onPaste={handlePasteNumbersOnly}
                                                pattern="[0-9]*"
                                                onChange={(e) =>
                                                    handleOutsideChange(key, e.target.value)
                                                }
                                            />
                                        </td>
                                        <td className="text-end">
                                            {taxValue ? taxValue.toLocaleString() : "0"}
                                        </td>
                                    </tr>
                                );
                            })}

                            <tr className="section-header">
                                <td colSpan="3"
                                    style={{ fontWeight: "500" }}>
                                    Total Capital Gain Report
                                </td>
                            </tr>

                            {tableStructure.map((label, index) => {
                                const key = gainKeys[index];
                                const insideAmount =
                                    finalData?.capitalGainInsideBajajBroking?.[key]?.amount || 0;

                                const insideTax =
                                    finalData?.capitalGainInsideBajajBroking?.[key]?.tax || 0;

                                const outsideAmount =
                                    Number(outsideValues[key] || 0);

                                const taxPerc =
                                    finalData?.capitalGainOutsideBajajBroking?.[key]?.taxPerc || 0;

                                const outsideTax =
                                    (outsideAmount * taxPerc) / 100;
                                return (
                                    <tr key={`total-${index}`}>
                                        <td>{label}</td>
                                        <td className="text-end">
                                            {(insideAmount + outsideAmount).toLocaleString()}
                                        </td>
                                        <td className="text-end">
                                            {(insideTax + outsideTax).toLocaleString()}
                                        </td>
                                    </tr>
                                );
                            })}


                            {tableCalculationLabel.map((label, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{label}</td>
                                        <td className="text-end">
                                            {label ===
                                                "Bank Interest Amount Credited in Bank account" ? (
                                                <input
                                                    type="text"
                                                    className="form-control text-end"
                                                    value={bankInterest}
                                                    onInput={onlyNumber}
                                                    maxLength={15}
                                                    onPaste={(e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    setBankInterest(pasted);
}}
                                                    // onPaste={handlePasteNumbersOnly}
                                                    onChange={(e) =>
                                                        setBankInterest(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            ) : label ===
                                                "Advance Tax Payable (A)" ? (advanceTaxPayable.toLocaleString()
                                            ) : label ===
                                                "Surcharge (B)" ? (
                                                surchargeAmount.toLocaleString()
                                            ) : label === "Health and Education Cess (C)" ? (
                                                healthEduValue.toLocaleString()
                                            ) : label === "Total Advance Tax Payable (D = A + B + C)" ? (
                                                totalAdvanceTaxPayable.toLocaleString()
                                            ) : label ===
                                                "Advance Tax Paid (E)" ? (
                                                <input
                                                    type="text"
                                                    className="form-control text-end"
                                                    value={advanceTaxPaid}
                                                    onInput={onlyNumber}
                                                    maxLength={15}
                                                    onPaste={(e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    setAdvanceTaxPaid(pasted);
}}
                                                    // onPaste={handlePasteNumbersOnly}
                                                    onChange={(e) =>
                                                        setAdvanceTaxPaid(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            ) : label ===
                                                "TDS Credit for Dividend + Bank Interest Received (F)" ? (
                                                <input
                                                    type="text"
                                                    maxLength={15}
                                                    onPaste={(e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
    setTdsCredit(pasted);
}}
                                                    // onPaste={handlePasteNumbersOnly}
                                                    className="form-control text-end"
                                                    value={tdsCredit}
                                                    onInput={onlyNumber}
                                                    onChange={(e) =>
                                                        setTdsCredit(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                            ) : (
                                                "0"
                                            )}
                                        </td>
                                        <td className="text-end">
                                            {label === "Bank Interest Amount Credited in Bank account"
                                                ? bankInterestTax
                                                    ? bankInterestTax.toLocaleString()
                                                    : "0"
                                                : ""}
                                        </td>
                                    </tr>
                                );
                            })}

                            <tr className="section-header">
                                <td colSpan="3"
                                    style={{ fontWeight: "500" }}>
                                    Net Advance Tax Payable ( G = D - E - F) : {""}
                                    {netAdvanceTaxPayable.toLocaleString()}

                                </td>
                            </tr>

                            <tr className="section-header">
                                <td colSpan="3"
                                    style={{ fontWeight: "500" }}>
                                    Advance Tax Liability = {""}
                                    {netAdvanceTaxPayable.toLocaleString()}
                                </td>
                            </tr>


                            {scrollLoader && (
                                <div className="loader-center">
                                    <LoaderForSearch />
                                </div>
                            )}
                        </tbody>
                    </table>
                ) : (
                    ""
                )}
            </div>
        </>
    );
}
export default AdvanceTaxReportTable;
